import { render, staticRenderFns } from "./settings-company-payment.vue?vue&type=template&id=b6abff7a&"
import script from "./settings-company-payment.ts?vue&type=script&lang=ts&"
export * from "./settings-company-payment.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports